module.exports = __webpack_public_path__ + "static/media/siddharth-tirupati-trip-05.722dd622.png";